export enum SessionStorageEnum {
  token = 'token',
  fullname = 'fullname',
  account = 'account',
  email = 'email',
}
